import { Alert, Button, Card, Form, InputNumber, Modal, Select, Spin, Table } from "antd";
import React from "react";
import { getFormFieldByType } from "../../util/methods";
import * as moment from "moment-timezone";
import _ from "lodash";
import AssetSearch from "../../components/AssetSearch";

class Create extends React.Component {
  state = {
    selectedAsset: null,
    selectedSI: [],
    visible: false,
    timeVisible: false,
    hideShowTask: false,
    createBtnVisible: false,
    formPayload: null,
    meterKmHr: {}
  };

  componentDidMount() {
    const { match, fetch } = this.props;
    if (match.params && match.params.id) {
      fetch(match.params.id);
    }
  }

  handleSubmit = e => {
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.log(err);
      }
      this.setState({
        formPayload: values,
        visible: true
      });
      // if(match.params && match.params.id) {
      //   this.props.onSubmit(values, match.params.id);
      // } else {
      //   this.props.onSubmit(values);
      // }
    });
  };

  onConfirmSubmit = () => {
    // console.log(this.state.formPayload);
  };

  onChangeAsset = val => {
    // console.log(val)
    this.props.getServiceIdentifierFromAsset(val);
    this.setState({
      selectedAsset: val,
      selectedSI: []
    });
    this.props.form.setFieldsValue({ asset: val });
    this.props.form.resetFields(["schedules"]);
  };

  changeServiceIdentifier = val => {
    // console.log(this.props.siData);
    // console.log(this.props.identifiers);
    // const { getFieldValue } = this.props.form;
    const identifiers = val; //getFieldValue("schedules");
    // console.log(identifiers);
    if (identifiers && identifiers.length && identifiers.length === 1) {
      const val = identifiers[0];
      const selectedSi = (this.props.identifiers || []).filter(
        si => si._id === val
      );
      // console.log(selectedSi);
      this.setState({
        createBtnVisible: false,
        hideShowTask: false,
        selectedSI: selectedSi && selectedSi.length ? selectedSi : []
        // visible: true,
      });
      const timeIntervals =
        (selectedSi && selectedSi[0] && selectedSi[0].timeIntervals) || [];
      // console.log(timeIntervals);
      timeIntervals.forEach(time => {
        // console.log(time);
        if (time.name === "KM" || time.name === "HOUR" || time.name === "KMS" || time.name === "HOURS")
          this.setState({ timeVisible: true });
      });
      this.props.fetchLastProcessed(this.state.selectedAsset, val);
    } else if (identifiers && identifiers.length && identifiers.length > 1) {
      const selectedSis = (this.props.identifiers || []).filter(si =>
        identifiers.includes(si._id)
      );
      // console.log(selectedSis);
      this.setState({
        createBtnVisible: false,
        hideShowTask: false,
        selectedSI: selectedSis && selectedSis.length ? selectedSis : null
        // visible: true,
      });
      let timeIntervals = [];
      let isSameTypeIdentifier = true,
        anyInterval = [];
      selectedSis.map(si => {
        timeIntervals = timeIntervals.concat(si.timeIntervals || []);
        anyInterval = si.timeIntervals || [];
      });
      const testIntervals = _.uniqWith(
        timeIntervals,
        (arrVal, othVal) => arrVal.name === othVal.name
      );
      // console.log(JSON.stringify((testIntervals || []).map(i => i.name)), JSON.stringify((anyInterval || []).map(i => i.name)));
      // if(JSON.stringify((testIntervals || []).map(i => i.name)) === JSON.stringify((anyInterval || []).map(i => i.name))) {
      timeIntervals.forEach(time => {
        // console.log(time);
        if (time.name === "KM" || time.name === "HOUR" || time.name === "KMS" || time.name === "HOURS")
          this.setState({ timeVisible: true });
      });
      this.props.fetchLastProcessed(
        this.state.selectedAsset,
        identifiers.toString()
      );
      // }
      // else {
      //   isSameTypeIdentifier = false;
      //   this.setState({hideShowTask: true, timeVisible: false});
      //   message.error(`Cannot merge Service Identifier(Schedules) as not of same type (having different time intervals`)
      // }
    }
  };

  toggleVisible = () => {
    this.setState({ visible: !this.state.visible });
  };

  handleConfirmOk = e => {
    e.preventDefault();
    this.setState({ createBtnVisible: true });
    this.toggleVisible();
    const { match } = this.props;
    // console.log(this.state.formPayload);
    if (match.params && match.params.id) {
      this.props.onSubmit(this.state.formPayload, match.params.id);
    } else {
      this.props.onSubmit(this.state.formPayload);
    }
  };

  taskModal = () => {
    let isDue = {};
    const selectedSI = this.state.selectedSI;
    // console.log(selectedSI, this.props.lastProcessedResource);
    let tasks = [],
      timeIntervals = [];
    selectedSI.map(si => {
      tasks = tasks.concat(
        (si.tasks || []).map(s => {
          // console.log(s)
          return { ...s.task, ...{ instruction: s.instruction }, ...{ schedule: si.serviceIdentifierNo } };
        })
      );
      timeIntervals = timeIntervals.concat(
        (si.timeIntervals || []).map(t => {
          return {
            ...t,
            ...{ schedule: si.serviceIdentifierNo, scheduleId: si._id }
          };
        })
      );
      isDue[si.serviceIdentifierNo] = false;
    });
    // timeIntervals = _.uniqWith(timeIntervals, (arrVal, othVal) => arrVal.name === othVal.name);
    // tasks = _.uniqWith(tasks, (arrVal, othVal) => arrVal.taskCode === othVal.taskCode);
    // console.log(tasks)
    /*
    tasks = tasks.reduce((acc, obj) => {
      const existingObj = acc.find(item => item.taskCode === obj.taskCode);
      if (existingObj) {
        if (Array.isArray(existingObj.schedule)) {
          if (!existingObj.schedule.includes(obj.schedule)) {
            existingObj.schedule.push(obj.si);
          }
        } else if (existingObj.schedule !== obj.schedule) {
          existingObj.schedule = [existingObj.schedule, obj.schedule];
        }
      } else {
        acc.push(obj);
      }
      return acc;
    }, []);
    */
    // console.log(tasks)
    const lastRecord = this.props.lastProcessedResource;
    // console.log(lastRecord);
    const {
      lastRecord: lastUnprocessedRecord,
      lastProcessedScheduleWise,
      lastProcessed
    } = lastRecord || {};
    const currentPayload = this.state.formPayload;

    let dueMessage = [];
    let notAllowedToCreate = false;
    if (lastUnprocessedRecord && !lastUnprocessedRecord.hasProcessed) {
      notAllowedToCreate = true;
    }
    timeIntervals.map(time => {
      // console.log(currentPayload);
      let duration = 0;
      const interval = time.value;

      let lastInterval = 0; // lastRecord && lastRecord.meterReading && lastRecord.meterReading[time.name] || 0;
      const scheduleRecord = (lastProcessedScheduleWise || []).filter(
        rec => rec.schedule === time.scheduleId
      );
      // console.log(scheduleRecord);
      const record =
        scheduleRecord &&
        scheduleRecord.length &&
        scheduleRecord[0].lastProcessed &&
        scheduleRecord[0].lastProcessed.meterReading.filter(
          reading => reading.name === time.name
        );
      // console.log(record);
      if (record && record.length) {
        lastInterval = (record[0] && record[0].value) || 0;
      }

      const currentDate = moment();
      let lastProcessedDate = null;
      if (
        scheduleRecord &&
        scheduleRecord.length &&
        scheduleRecord[0].lastProcessed &&
        scheduleRecord[0].lastProcessed.processedOn
      ) {
        lastProcessedDate = moment(scheduleRecord[0].lastProcessed.processedOn);
      }

      const currentInterval =
        (currentPayload &&
          currentPayload.meterReading &&
          currentPayload.meterReading[time.scheduleId] &&
          currentPayload.meterReading[time.scheduleId][time.name]) ||
        0;

      switch (time.name.toUpperCase()) {
        case "DAY":
          duration = lastProcessedDate
            ? currentDate.diff(lastProcessedDate, "days")
            : 0;
          break;
        case "DAYS":
          duration = lastProcessedDate
            ? currentDate.diff(lastProcessedDate, "days")
            : 0;
          break;
        case "WEEK":
          duration = lastProcessedDate
            ? currentDate.diff(lastProcessedDate, "weeks")
            : 0;
          break;
        case "WEEKS":
          duration = lastProcessedDate
            ? currentDate.diff(lastProcessedDate, "weeks")
            : 0;
          break;
        case "MONTH":
          duration = lastProcessedDate
            ? currentDate.diff(lastProcessedDate, "months")
            : 0;
          break;
        case "MONTHS":
          duration = lastProcessedDate
            ? currentDate.diff(lastProcessedDate, "months")
            : 0;
          break;
        case "YEAR":
          duration = lastProcessedDate
            ? currentDate.diff(lastProcessedDate, "years")
            : 0;
          break;
        case "YEARS":
          duration = lastProcessedDate
            ? currentDate.diff(lastProcessedDate, "years")
            : 0;
          break;
        default:
          duration = currentInterval - lastInterval;
          break;
      }

      if (!isDue[time.schedule]) {
        isDue[time.schedule] = duration >= interval;
      }
      const lastReading =
        (time.name === "KM" || time.name === "HOUR" || time.name === "KMS" || time.name === "HOURS")
          ? `Last service reading is : ${lastInterval} ${time.name}`
          : "";
      // [SRVI-4] HOUR difference is 500HOUR (1000HOUR) Last reading : 1000HOUR
      // [SRVI-4] (1000HOURS) Last service reading is 1000 HOURS and difference is: 500 HOURS
      dueMessage.push({
        message: `[${time.schedule}] (${time.value}${time.name}) ${lastReading ? lastReading + " and " : " "
          }difference is : ${duration} ${time.name}`,
        isDue: isDue[time.schedule]
      });
    });
    // console.log(isDue);
    // console.log(tasks);
    const cols = [
      {
        title: "Code",
        dataIndex: "taskCode",
        key: "taskCode",
        width: "100px"
      },
      {
        title: "Schedule",
        dataIndex: "schedule",
        key: "schedule",
        width: "150px",
        render: (_, record) => record.schedule && record.schedule.toString()
      },
      {
        title: "Name",
        dataIndex: "taskName",
        key: "taskName",
        width: "200px"
      },
      {
        title: "Instruction",
        dataIndex: "instruction",
        key: "instruction",
        width: "150px"
      },
      {
        title: "Compulsory",
        dataIndex: "compulsory",
        key: "compulsory",
        render: (_, record) => (record.allowToSkip ? "No" : "Yes")
      }
    ];

    return (
      <Modal
        title={`Preview Tasks ${lastRecord && lastRecord.processedOn
          ? ` (Last processed on ${moment(lastRecord.processedOn).format(
            "DD-MM-YYYY"
          )})`
          : ""
          }`}
        visible={this.state.visible}
        okText={
          notAllowedToCreate
            ? ""
            : dueMessage.filter(d => d.isDue).length
              ? "Ok"
              : "Yes I Confirm"
        }
        onOk={!notAllowedToCreate ? this.handleConfirmOk : null}
        onCancel={this.toggleVisible}
        maskClosable={false}
        width={700}
      >
        <div>
          {notAllowedToCreate && (
            <Alert
              message="Cannot create this checklist!"
              description={`Unprocessed PM List ${lastUnprocessedRecord &&
                lastUnprocessedRecord.code} already exist`}
              type={"error"}
              showIcon
            />
          )}
          {dueMessage.map((msg, ix) => (
            <Alert
              key={`due${ix}`}
              message=""
              description={msg.message}
              type={msg.isDue ? "warning" : "info"}
              showIcon
            />
          ))}

          <Table
            size={"small"}
            pagination={false}
            scroll={{ y: true }}
            bordered
            dataSource={tasks}
            columns={cols}
            rowKey={(record, index) => `${record._id}_${index}`}
          />

          {Object.keys(isDue).map((d, ix) =>
            isDue[d] ? (
              <Alert
                key={ix}
                message="Overdue"
                description={`Maintenance schedule ${d} is already due. `}
                type={"error"}
                showIcon
              />
            ) : (
              <Alert
                key={ix}
                message="Not Overdue"
                description={`Maintenance schedule ${d} is not due yet. Still want to create?`}
                type={"info"}
                showIcon
              />
            )
          )}
        </div>
      </Modal>
    );
  };

  setMeterKmHr = (val, name, index) => {
    // console.log(val, name);
    // e.preventDefault();
    const meterKmHr = this.state.meterKmHr;
    meterKmHr[name] = { val, index };
    this.setState({
      meterKmHr: meterKmHr
    });
  };

  meterReading = () => {
    const { getFieldDecorator } = this.props.form;
    const selectedSi = this.state.selectedSI;
    const meterKmHr = this.state.meterKmHr;
    // const timeIntervals = (selectedSi && selectedSi.timeIntervals) || [];
    let timeIntervals = [];
    selectedSi.map(si => {
      // console.log(si)
      timeIntervals = timeIntervals.concat(
        (si.timeIntervals || []).map(s => ({
          ...s,
          schedule: si._id,
          scheduleNo: si.serviceIdentifierNo
        }))
      );
    });
    const lastRecord = this.props.lastProcessedResource;
    const {
      lastRecord: lastUnprocessedRecord,
      lastProcessedScheduleWise,
      lastProcessed
    } = lastRecord || {};
    // console.log(timeIntervals)
    return (
      !this.state.visible &&
      timeIntervals.map((time, index) => {
        // console.log(time, index)
        // if(time.name === 'KM' || time.name === 'HOUR') {
        let lastProcessedDate = null;
        const scheduleRecord = (lastProcessedScheduleWise || []).filter(
          rec => rec.schedule === time.schedule
        );
        const record =
          scheduleRecord &&
          scheduleRecord.length &&
          scheduleRecord[0].lastProcessed;
        // console.log(record);
        if (record && record.hasProcessed && record.processedOn) {
          lastProcessedDate = moment(record.processedOn);
        }
        let duration = 0;
        let currentDate = moment();
        switch (time.name.toUpperCase()) {
          case "DAY":
            duration = lastProcessedDate
              ? currentDate.diff(lastProcessedDate, "days")
              : 0;
            break;
          case "DAYS":
            duration = lastProcessedDate
              ? currentDate.diff(lastProcessedDate, "days")
              : 0;
            break;
          case "WEEK":
            duration = lastProcessedDate
              ? currentDate.diff(lastProcessedDate, "weeks")
              : 0;
            break;
          case "WEEKS":
            duration = lastProcessedDate
              ? currentDate.diff(lastProcessedDate, "weeks")
              : 0;
            break;
          case "MONTH":
            duration = lastProcessedDate
              ? currentDate.diff(lastProcessedDate, "months")
              : 0;
            break;
          case "MONTHS":
            duration = lastProcessedDate
              ? currentDate.diff(lastProcessedDate, "months")
              : 0;
            break;
          case "YEAR":
            duration = lastProcessedDate
              ? currentDate.diff(lastProcessedDate, "years")
              : 0;
            break;
          case "YEARS":
            duration = lastProcessedDate
              ? currentDate.diff(lastProcessedDate, "years")
              : 0;
            break;
        }
        // console.log(this.state.meterKmHr, duration);
        const initialValue =
          (time.name === "KM" || time.name === "HOUR" || time.name === "KMS" || time.name === "HOURS")
            ? meterKmHr[time.name] && meterKmHr[time.name]['val'] || 0
            : duration;
        // console.log(meterKmHr, index)
        // console.log(meterKmHr && meterKmHr[time.name], index, meterKmHr[time.name]['index'])
        return (
          <Form.Item
            key={`${time.schedule}-${time.name}`}
            label={`Current ${time.name} (${time.scheduleNo}) ${(time.name === "KM" || time.name === "HOUR" || time.name === "KMS" || time.name === "HOURS") ? "Meter" : ""
              } Reading`}
          >
            {getFieldDecorator(`meterReading[${time.schedule}][${time.name}]`, {
              rules: [
                {
                  required: time.name === "KM" || time.name === "HOUR" || time.name === "KMS" || time.name === "HOURS",
                  message: `${time.name} reading is required!`
                }
              ],
              initialValue: initialValue
            })(
              <InputNumber
                style={{ width: 300 }}
                min={0}
                onBlur={
                  (time.name === "KM" || time.name === "HOUR" || time.name === "KMS" || time.name === "HOURS")
                    ? e => this.setMeterKmHr(e.target.value, time.name, index)
                    : null
                }
                disabled={
                  // !((time.name === "KM" || time.name === "HOUR" || time.name === "KMS" || time.name === "HOURS"))
                  (time.name !== "KM" && time.name !== "HOUR" && time.name !== "KMS" && time.name !== "HOURS") || (meterKmHr && meterKmHr[time.name] && meterKmHr[time.name]['index'] !== index)
                  // this.state.meterKmHr[time.name] && index > 0
                }
                placeholder={`Current ${time.name} reading`}
              />
            )}
          </Form.Item>
        );
        // }
      })
    );
  };

  assetSearch = (value) => {
    this.props.searchGlobalAssetData(value);
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const {
      data,
      loading,
      filters,
      title,
      resource,
      form,
      identifiers,
      identifierData
    } = this.props;
    // console.log(identifiers);
    return (
      <Spin spinning={loading}>
        <Card
          className={`gx-card-metrics`}
          title={`${title} ${"PM Checklist"}`}
        >
          <Form onSubmit={this.handleSubmit} layout="vertical">
            {Object.keys(filters).map(item => {
              if (item === "asset") {
                // return getFormFieldByType(
                //     filters,
                //     item,
                //     getFieldDecorator,
                //     data,
                //     {
                //         setFieldsValue: this.props.form.setFieldsValue,
                //         title: this.props.title,
                //         onChange: this.onChangeAsset
                //     }
                // );

                return <Form.Item
                  key={"asset"}
                  label={"Enter Asset"}
                  style={{ width: "100%" }}
                >
                  {getFieldDecorator(`asset`, {
                    rules: [{ required: true, message: `Asset is required!` }],
                    initialValue: data && data.asset && data.asset._id,
                  })(
                    <AssetSearch
                      styleName="gx-lt-icon-search-bar-lg"
                      placeholder="Search Assets..."
                      onChange={this.assetSearch.bind(this)}
                      onSelect={(value) => value && this.onChangeAsset(value)}
                      assetData={
                        this.props.assetData && this.props.assetData.filter((ast) => ast.assetModel)
                      } // only assets with assetModel
                      authUser={this.props.authUser}
                      loading={this.props.assetSearchLoading}
                      defaultAsset={data && data.asset}
                    />,
                  )}
                </Form.Item>
              }
              if (item === "schedules") {
                return (
                  <Form.Item key={"schedules"} label={"Search PM Schedules"}>
                    {getFieldDecorator(`schedules`, {
                      rules: [
                        {
                          required: true,
                          message: `Schedules is required!`
                        }
                      ]
                    })(
                      <Select
                        showSearch
                        mode="multiple"
                        filterOption={(input, option) =>
                          (option.props.children + "")
                            .toLowerCase()
                            .indexOf((input + "").toLowerCase()) >= 0
                        }
                        // onSelect={this.changeServiceIdentifier}
                        onChange={(val, options) =>
                          this.changeServiceIdentifier(val, options)
                        }
                        placeholder={"ex. abc"}
                      >
                        {identifiers &&
                          identifiers.map(item => {
                            return (
                              <Select.Option key={item._id} value={item._id}>
                                {item["serviceIdentifierName"]} -{" "}
                                {item["serviceIdentifierNo"]}
                              </Select.Option>
                            );
                          })}
                      </Select>
                    )}
                  </Form.Item>
                );
              }
            })}
            {this.state.timeVisible ? this.meterReading() : null}
            <Form.Item>
              <Button
                type="primary"
                className="gx-mb-0"
                htmlType="button"
                loading={loading}
                style={{ display: !this.state.createBtnVisible ? "none" : "" }}
                disabled={!this.state.createBtnVisible}
                onClick={this.onConfirmSubmit}
              >
                {this.props.title === "EDIT" ? "UPDATE" : "CREATE NOW"}
              </Button>
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                className="gx-mb-0"
                htmlType="submit"
                loading={loading}
                hidden={this.state.hideShowTask}
                style={{ display: this.state.createBtnVisible ? "none" : "" }}
              >
                Show Tasks
              </Button>
            </Form.Item>
          </Form>
        </Card>
        {this.state.visible && this.taskModal()}
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: "global_state",
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  }
})(Create);

export default CreateForm;
